exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ruleDashboard{padding:30px}.ruleDashboard .dashboardCont{background-color:#ffffff;box-shadow:0px 1px 5px rgba(0,0,0,0.1);min-height:calc(100vh - 300px);border-radius:5px}.ruleListHead{padding-bottom:25px}h2{color:#265390;font-size:20px;font-weight:600;display:inline-block;margin-right:20px}.btn-secondary{font-weight:600;padding:6px 12px}.btn-secondary span{display:inline-block}.btn-secondary span.icon{margin-right:6px}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/rules/rules-list/rules-list.component.scss
// module id = 1377
// module chunks = 1